import { render, staticRenderFns } from "./CosCreation.vue?vue&type=template&id=b91f995c&lang=pug"
import script from "./CosCreation.vue?vue&type=script&lang=ts"
export * from "./CosCreation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CosCreation.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FHighlights%2FSW%2FHighlight%2FCosCreation.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports